import React, { useState } from 'react'
import * as s from './Header.module.css'
import { StaticImage } from 'gatsby-plugin-image'
import ProgressBar from './ProgressBar'

const Header = (props) => {
    const [burgerStyle,setBurgerStyle] = useState({ display:'none'})

    let openBurger = () => {
        setBurgerStyle({display: 'block'})
    }

    let closeBurger = () => {
        setBurgerStyle({display: 'none'})
    }

    return (
        <>
            <div className={s.wrapper}>
                <div className={s.container}>
                    <StaticImage className={s.logoIcon} src="../../images/ihk-logo-rgb.svg" alt="logo icon"/>
                    <StaticImage onClick={openBurger} className={s.menuBurgerIcon} src="../../images/menuBurger.svg" alt="menu Burger icon"/>
                </div>
                <div className={s.menuBurger} style={burgerStyle}>
                    <StaticImage onClick={closeBurger} className={s.close} src="../../images/close.svg" alt="menu Burger icon"/>
                </div>
            </div>
            <ProgressBar width="15%"/>
        </>
    )

}

export default Header;
